import styled, { css } from 'styled-components';
import type * as React from 'react';

import { DropdownMenu } from 'components/common';

export const Backdrop = styled.div<{ $show: boolean }>(({ $show }) => css`
  display: ${$show ? 'block' : 'none'};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: transparent;
  z-index: 50;
  cursor: default;
`);

export const BrandDropdown = styled(DropdownMenu)<{
  $posx: string, $posy: string, onClick?:(e: React.BaseSyntheticEvent) => void
    }>(({ theme, $posx, $posy }) => css`
  left: ${$posx === 'right' ? 0 : 'unset'};
  right: ${$posx === 'left' ? 0 : 'unset'};
  top: ${$posy === 'bottom' ? '80%' : 'unset'};
  bottom: ${$posy === 'top' ? '80%' : 'unset'};

  border: 1px solid ${theme.colors.brand.tertiary};

  & li button {
    background: none;
    border: none;
    padding: 6px;
    min-width: 95px;
    text-align: left;
    width: 100%;
    color: ${theme.colors.brand.tertiary};

    &:hover {
      background-color: ${theme.colors.global.contentBackground};
    }
  }
`);
